export interface Invoice {
  bpNumber: string;
  customerName: string;
  employeeId: string;
  totalAmount: number;
  id: number;
  invoiceDate: string;
  invoiceNumber: string;
  poNumber: string;
  salesRepresentative: string;
}

export class InvoiceResponse {
  count: number;
  invoices: Invoice[];

  constructor() {
    this.count = 0;
    this.invoices = [];
  }
}
